import { map } from 'underscore';

export const processEdmResult = (data, isError = false) => {
  if (isError) {
    return { items: [], totalCount: 0 };
  }
  const totalCount = data['@odata.count'];
  const items = map(data.value, item => ({
    Id: item.Id,
    name: item.Name,
    status: item.Status,
    campaignName: item.Campaign ? item.Campaign.Name : null,
    CampaignId: item.Campaign ? item.Campaign.Id : null,
  }));
  return { items, totalCount };
};

export const processEdmResultAccount = (data, isError = false) => {
  if (isError) {
    return { items: [], totalCount: 0 };
  }
  const totalCount = data['@odata.count'];
  const items = map(data.value, item => ({
    Id: item.Id,
    name: item.Name,
    status: item.AccountInactiveReasonsCount > 0 ? 'AccountError' : 'AccountActive',
  }));
  return { items, totalCount };
};
